import { bindQueryParams } from "src/helpers/tools";
import { methods, request } from "./base";

const configApis = {
  // current_date: "2025-08-11"
  getReminders: async (params: { user_id: string; current_date: string }) => {
    const url = bindQueryParams("/gfc/homescreen/reminders", params);
    return await request({
      method: methods.GET,
      route: url,
      priv: true,
    });
  },
};

export default configApis;
